<template>
  <div id="admin">
    <el-container>

      <el-header style="display:flex;background-color: #f2f5f6;box-shadow:0px 10px 10px 0px rgba(47,79,47,0.5)">

        <div style="width:14%;height:60px;"></div>

        <div style="width:76%;height:60px;display: flex;">
          <div id="header-company-avatar">
            <el-avatar shape="square" size="large" src="../../wybd-logo.png"></el-avatar>
          </div>

          <p style="display:inline;float: left;width:10px"></p>

          <div id="header-company">
            <el-button type="text" style="color:green" @click="showHello">
              <span style="font-size:18px">{{ companyName }}</span>
            </el-button>
          </div>
        </div>

        <div style="width:10%;height:60px;display: flex;">
          <div id="header-avatar">
            <el-avatar :src="avatar"></el-avatar>
          </div>

          <div id="header-username">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                {{ username }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="personalCenter"
                  v-loading.fullscreen.lock="fullscreenLoading">个人中心</el-dropdown-item>
                <el-dropdown-item divided command="logout">退出系统</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-header>

      <div style="width: 100%;height: 10px;"></div>

      <el-container style="width:100%;height:900px;">
        <el-aside style="width:210px;background-color: #f2f5f6;box-shadow:10px 0px 10px 0px rgba(47,79,47,0.5)">
          <div style="width: 100%;height: 10px;"></div>

          <el-radio-group v-model="isCollapse" style="margin-bottom: 20px;" fill="green" @input="radioInput">
            <el-radio-button :label="true">收起</el-radio-button>
            <el-radio-button :label="false">展开</el-radio-button>
          </el-radio-group>

          <el-menu default-active="1-4-1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
            @select="handleSelect" :collapse="isCollapse" :unique-opened="true">

            <el-menu-item index="/admin/tenantAdmin">
              <i class="el-icon-school"></i>
              <span slot="title">租户管理</span>
            </el-menu-item>

            <el-menu-item index="/admin/disputesAdmin">
              <i class="el-icon-document"></i>
              <span slot="title">纠纷管理</span>
            </el-menu-item>

            <el-menu-item index="/admin/userAdmin">
              <i class="el-icon-user"></i>
              <span slot="title">用户管理</span>
            </el-menu-item>

            <el-menu-item index="/admin/tmplAdmin">
              <i class="el-icon-user"></i>
              <span slot="title">模版管理</span>
            </el-menu-item>

            <!-- <el-menu-item index="/tenantAdmin">
                <i class="el-icon-notebook-2"></i>
                <span slot="title">日志管理</span>
              </el-menu-item> -->
            <!-- <el-menu-item index="/tenantAdmin">
                <i class="el-icon-menu"></i>
                <span slot="title">账单管理</span>
              </el-menu-item> -->
          </el-menu>
        </el-aside>

        <el-container style="height:900px;">
          <el-main>
            <keep-alive>
              <router-view></router-view>
            </keep-alive>
          </el-main>
        </el-container>

      </el-container>

      <div style="width: 100%;height: 10px;"></div>

      <el-footer style="background-color: #f2f5f6;box-shadow:0px -10px 10px 0px rgba(47,79,47,0.5)">
        <p style="color: #6f5499;"><a href="https://beian.miit.gov.cn">粤ICP备2022114400号-3</a></p>
      </el-footer>

    </el-container>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  data() {
    return {
      defaultPath: this.getDefaultPath(),
      token: this.getToken(),
      userId: this.getUserId(),
      companyId: this.getCompanyId(),

      companyName: '中国制造',

      isCollapse: false,
      isShowHello: true,
      isShowPage: '',

      username: 'wx_ijbvzt',
      avatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',

      fullscreenLoading: false
    }
  },
  components: {},
  methods: {
    showHello() {

      this.isShowPage = ''

      this.setDefaultPath('/admin/hello')

      this.$router.push({ path: '/admin/hello' })
    },
    handleOpen(key, keyPath) {
      //console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      //console.log(key, keyPath)
    },
    handleSelect(key, keyPath) {
      // console.log(key)

      if (key.length > 3) {

        this.setDefaultPath(key)

        this.defaultPath = key

        this.$router.push({ path: key })/*.catch(err => {err})*/
      }

      this.isShowPage = key

      this.isShowHello = false

      // console.log(keyPath);
    },
    handleCommand(command) {
      if (command == "logout") {

        this.logout()

      } else if (command == "personalCenter") {

        this.personalCenter(1)
      }
    },
    getCompanyInfo() {
      //alert("getCompanyInfo")
    },
    personalCenter(val) {

      this.isShowPage = false

      this.setPersonalCenter(val)

      this.isShowHello = false
      // console.log("start")
      this.fullscreenLoading = true

      setTimeout(() => {
        this.isShowHello = true

        this.fullscreenLoading = false
      }, 900)

    },
    logout() {
      this.$axios({
        method: "POST",
        url: "/shiro/sys/logout",
        data: {},
        headers: {
          token: this.token
        }
      }).then(result => {

        if (result.status === 200) {

          const data = result.data

          if (data.status === 200) {
            this.$message({
              showClose: true,
              message: data.msg,
              type: "success",
              duration: "1600"
            })
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: "error",
              duration: "3000"
            })
          }

          this.setToken("")

          this.$router.push({ path: "/Login" })
          
        } else {
          this.$message({
            showClose: true,
            message: "操作失败，请联系管理员",
            type: "error",
            duration: "3000"
          })
        }
      })
    },
    radioInput(val) {
      //console.log(val)
    },
    getUser() {
      // console.log('getUser')
      // console.log(this.token)

      this.$axios({
        method: "get",
        url: "/shiro/user/get?userId=" + this.userId,
        data: {},
        headers: {
          token: this.token
        }
      }).then(result => {

        const data = result.data

        if (data.status === 400) {
          this.$message(data.msg)

          this.$router.push({ path: "/Login" })
        }

        this.username = data.data.username
        this.avatar = data.data.avatar
      })
    }
  },
  mounted() {
    // console.log('Admin.vue-->mounted()')
    // console.log(this.defaultPath)

    this.setCurrentSystem(1)

    this.$router.push({ path: this.defaultPath }).catch(err => { err })

    this.setPersonalCenter(0)

    //alert(this.$route.query.userId)
    this.getUser()

    this.$axios({
      method: "post",
      url: "/shiro/company/get",
      data: {
        id: this.companyId
      }, headers: {
        token: this.token
      }
    }).then(result => {

      this.companyName = result.data.data.companyName
      // this.companyName =this.companyName.length<=8?this.companyName:this.companyName.substring(0,7)+'...'
    })

  },
  updated() {
    // console.log('updated')
  }
}
</script>

<style>
#header-company-avatar {
  padding: 10px 0;
}

#header-company {
  padding: 10px 0;
}

#header-username {
  padding: 20px 0px 20px 10px;
}

#header-avatar {
  padding: 10px 0;
}

.el-dropdown-link {
  cursor: pointer;
  color: green;
}

.el-icon-arrow-down {
  font-size: 13px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

#hello-hello {
  height: 50px;
  line-height: 50px;
  color: green;
  background-color: #f2f5f6;
  border-radius: 5px;
  border: 1px solid green;
  margin: 0 0 20px 0;
}

.el-menu-item {
  color: green;
}

.el-menu-item.is-active {
  color: white;
  background-color: green;
}
</style>